import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Gift, Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAdmin } from '@/hooks/useAdmin';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();

  return (
    <header className="sticky top-0 z-40 w-full border-b bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 hover:scale-110 transition-all">
          <Gift className="w-6 h-6 text-primary glow-ai" />
          <span className="text-xl font-bold">Budgetter</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-4 flex-1 justify-end">
          <Link to="/" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Startseite
          </Link>
          <Link to="/magazin" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Magazin
          </Link>
          <Link to="/ueber-uns" className="text-sm text-muted-foreground hover:text-primary transition-colors">
            Über uns
          </Link>
          {isAdmin && (
            <Button 
              size="sm" 
              variant="outline"
              onClick={() => navigate('/admin/dashboard')}
              className="gap-2 min-h-[44px]"
            >
              Admin
            </Button>
          )}
          <Button 
            size="sm" 
            onClick={() => navigate('/questionnaire')}
            className="gap-2 min-h-[44px]"
          >
            <Gift className="w-4 h-4" />
            Geschenk-Assistent öffnen
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 hover:bg-accent rounded-lg transition-colors min-h-[44px] min-w-[44px]"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "Menü schließen" : "Menü öffnen"}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-menu"
        >
          {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div id="mobile-menu" className="absolute top-16 left-0 right-0 bg-background/98 backdrop-blur-sm border-b md:hidden">
            <nav className="container mx-auto px-4 py-6 flex flex-col gap-4" aria-label="Mobile Navigation">
              <Link 
                to="/" 
                className="text-sm text-muted-foreground hover:text-primary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Startseite
              </Link>
              <Link 
                to="/magazin" 
                className="text-sm text-muted-foreground hover:text-primary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Magazin
              </Link>
              <Link 
                to="/ueber-uns" 
                className="text-sm text-muted-foreground hover:text-primary transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Über uns
              </Link>
              {isAdmin && (
                <Button 
                  size="sm" 
                  variant="outline"
                  onClick={() => {
                    navigate('/admin/dashboard');
                    setMobileMenuOpen(false);
                  }}
                  className="w-full gap-2"
                >
                  Admin
                </Button>
              )}
              <Button 
                size="sm" 
                onClick={() => {
                  navigate('/questionnaire');
                  setMobileMenuOpen(false);
                }}
                className="w-full gap-2"
              >
                <Gift className="w-4 h-4" />
                Geschenk-Assistent öffnen
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};